import { instance, GETREQUESTOPTIONS } from '../apiService';
import { FolderSort } from './folderService';
import { ViewMode } from '../../components/ui-components/ViewModeToggle';

export interface FolderPreferences {
    sort?: FolderSort;
    view?: ViewMode;
}

export const getFolderPreferences = async (): Promise<FolderPreferences> => {
    const res = await instance.get(
        '/api/user-profile/settings',
        GETREQUESTOPTIONS()
    );
    return res.data?.folders ?? {};
};

export const saveFolderPreferences = async (
    prefs: FolderPreferences
): Promise<FolderPreferences> => {
    const res = await instance.post(
        '/api/user-profile/folder-settings',
        prefs,
        GETREQUESTOPTIONS()
    );
    return res.data ?? {};
};

export interface RoomPreferences {
    view?: ViewMode;
}

export const getRoomPreferences = async (): Promise<RoomPreferences> => {
    const res = await instance.get(
        '/api/user-profile/settings',
        GETREQUESTOPTIONS()
    );
    return res.data?.rooms ?? {};
};

export const saveRoomPreferences = async (
    prefs: RoomPreferences
): Promise<RoomPreferences> => {
    const res = await instance.post(
        '/api/user-profile/room-settings',
        prefs,
        GETREQUESTOPTIONS()
    );
    return res.data ?? {};
};
